import React, { useEffect, useState } from 'react'
import ImageWithBasePath from '../../core/img/imagewithbasebath'
import { Link } from 'react-router-dom'
import { Tooltip } from 'antd';
import { useShopRoutes } from '../../hooks/useShopRoutes';
//import { Settings, User } from 'feather-icons-react/build/IconComponents';
// import { useShopRoutes } from "../../hooks/useShopRoutes";
import { useIsOnline } from 'react-use-is-online';

import { useDispatch } from 'react-redux';
import { logoutUser } from '../../core/redux/auth.slice';

const PosHeader = () => {
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(logoutUser());
    };

    const [isFullscreen, setIsFullscreen] = useState(false);
    const route = useShopRoutes();
    const { isOnline, isOffline } = useIsOnline();
    

    const toggleFullscreen = (elem) => {
        elem = elem || document.documentElement;
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement &&
            !document.msFullscreenElement
        ) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    };

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(
                document.fullscreenElement ||
                document.mozFullScreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement
            );
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("mozfullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.addEventListener("msfullscreenchange", handleFullscreenChange);

        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener(
                "mozfullscreenchange",
                handleFullscreenChange
            );
            document.removeEventListener(
                "webkitfullscreenchange",
                handleFullscreenChange
            );
            document.removeEventListener(
                "msfullscreenchange",
                handleFullscreenChange
            );
        };
    }, []);


    const [ctime, setTime] = useState(new Date().toLocaleTimeString([], { hour12: false }))

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date().toLocaleTimeString([], { hour12: false }))
        }, 1000) // Update every second

        return () => clearInterval(interval) // Cleanup on unmount
    }, [])

    const onlineStatus = () => {
        if (isOnline) return <span className="d-inline-flex align-items-center p-2 pe-2 rounded-1 text-white bg-success fs-10"> <i className="ti ti-point-filled me-1 fs-11"></i>En ligne</span>
        if (isOffline) return <span className="d-inline-flex align-items-center p-2 pe-2 rounded-1 text-white bg-danger fs-10"> <i className="ti ti-point-filled me-1 fs-11"></i>Hors ligne</span>

        return <></>
    }

    return (
        <>
            {/* Header */}
            <div className="header pos-header">
                {/* Logo */}
                <div className="header-left active">
                    <Link to={route.newdashboard} className="logo logo-normal">
                        <ImageWithBasePath src="assets/img/MDS_logo.jpg" alt="Img" />
                    </Link>
                    <Link to={route.newdashboard} className="logo logo-white">
                        <ImageWithBasePath src="assets/img/logo-white.png" alt="Img" />
                    </Link>
                    <Link to={route.newdashboard} className="logo-small">
                        <ImageWithBasePath src="assets/img/logo-small.png" alt="Img" />
                    </Link>
                </div>
                {/* /Logo */}
                <Link id="mobile_btn" className="mobile_btn d-none" to="#sidebar">
                    <span className="bar-icon">
                        <span />
                        <span />
                        <span />
                    </span>
                </Link>
                {/* Header Menu */}
                <ul className="nav user-menu">
                    {/* Search */}
                    <li className="nav-item time-nav">
                        <span className="bg-secondary text-white d-inline-flex align-items-center">
                            <ImageWithBasePath
                                src="assets/img/icons/clock-icon.svg"
                                alt="img"
                                className="me-2"
                            />
                            {ctime}
                        </span>
                    </li>

                    <li className="nav-item">
                        {onlineStatus()}
                    </li>
                    <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
                        <Link
                            to="#"
                            className="dropdown-toggle nav-link select-store"
                            data-bs-toggle="dropdown"
                        >
                            <span className="user-info">
                                <span className="user-letter">
                                    <ImageWithBasePath
                                        src="assets/img/store/store-01.png"
                                        alt="Store Logo"
                                        className="img-fluid"
                                    />
                                </span>
                                <span className="user-detail">
                                    <span className="user-name">PDV</span>
                                </span>
                            </span>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                            <Link to="#" className="dropdown-item">
                                <ImageWithBasePath
                                    src="assets/img/store/store-01.png"
                                    alt="Store Logo"
                                    className="img-fluid"
                                />
                                La Marsa
                            </Link>
                            <Link to="#" className="dropdown-item">
                                <ImageWithBasePath
                                    src="assets/img/store/store-02.png"
                                    alt="Store Logo"
                                    className="img-fluid"
                                />
                                Taïeb
                            </Link>

                        </div>
                    </li>
                    {/* /Select Store */}
                    <li className="nav-item nav-item-box">
                        <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#calculator"
                            className="bg-orange border-orange text-white"
                        >
                            <i className="ti ti-calculator" />
                        </Link>
                    </li>
                    <li className="nav-item nav-item-box">
                        <Tooltip title='Plein écran' placement='right'>
                            <Link
                                to="#"
                                id="btnFullscreen"
                                onClick={() => toggleFullscreen()}
                                className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
                            >
                                <i className="ti ti-maximize" />
                            </Link>
                        </Tooltip>

                    </li>
                    <li
                        className="nav-item nav-item-box"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Chiffre d&apos;affiares"
                    >
                        <Tooltip title='Chiffre d&apos;affiares' placement='right'>
                            <Link to="#" data-bs-toggle="modal" data-bs-target="#cash-register">
                                <i className="ti ti-cash" />
                            </Link>
                        </Tooltip>

                    </li>

                    <li
                        className="nav-item nav-item-box"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Journal de caisse"
                    >
                        <Tooltip title='Journal de caisse' placement='right'>
                            <Link to="#" data-bs-toggle="modal" data-bs-target="#today-profit">
                                <i className="ti ti-chart-infographic" />
                            </Link>
                        </Tooltip>
                    </li>


                    <li className="nav-item dropdown has-arrow main-drop profile-nav">
                        <Link
                            to="#"
                            className="nav-link userset"
                            data-bs-toggle="dropdown"
                        >
                            <span className="user-info p-0">
                                <span className="user-letter">
                                    <ImageWithBasePath
                                        src="assets/img/profiles/avator1.jpg"
                                        alt="Img"
                                        className="img-fluid"
                                    />
                                </span>
                            </span>
                        </Link>
                        <div className="dropdown-menu menu-drop-user">
                            <div className="profileset d-flex align-items-center">
                                <span className="user-img me-2">
                                    <ImageWithBasePath src="assets/img/profiles/avator1.jpg" alt="Img" />
                                </span>
                                <div>
                                    <h6 className="fw-medium">Med KABANI</h6>
                                    <p>Admin</p>
                                </div>
                            </div>
                            <Link className="dropdown-item" to={route.profile}>
                                <i className="ti ti-user-circle me-2" />
                                Mon profile
                            </Link>

                            <Link className="dropdown-item" to={route.generalsettings}>
                                <i className="ti ti-settings-2 me-2" />
                                Paramètres
                            </Link>
                            <hr className="my-2" />
                            <Link className="dropdown-item logout pb-0" onClick={handleLogout}>
                                <i className="ti ti-logout me-2" />
                                Se déconnecter
                            </Link>
                        </div>
                    </li>
                </ul>
                {/* /Header Menu */}
                {/* Mobile Menu */}
                <div className="dropdown mobile-user-menu">
                    <Link
                        to="#"
                        className="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i className="fa fa-ellipsis-v" />
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                        <Link className="dropdown-item" to={route.profile}>
                            My Profile
                        </Link>
                        <Link className="dropdown-item" to={route.generalsettings}>
                            Settings
                        </Link>
                        <Link className="dropdown-item" onClick={handleLogout}>
                            Logout
                        </Link>
                    </div>
                </div>
                {/* /Mobile Menu */}
            </div>
            {/* Header */}
        </>

    )
}

export default PosHeader
